module.exports = __webpack_public_path__ + "static/media/loaf.bceb20f5.jpg";